var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.9832 5.48122L3.66955 16.7949L3.42464 19.4889C3.3681 20.1109 3.88914 20.6319 4.51107 20.5754L7.20509 20.3304L18.5188 9.01675L14.9832 5.48122Z","key":0}),React.createElement("path",{"d":"M19.2259 8.30964L21.3472 6.18831C21.7377 5.79778 21.7377 5.16462 21.3472 4.77409L19.2259 2.65277C18.8354 2.26225 18.2022 2.26225 17.8117 2.65277L15.6904 4.77411L19.2259 8.30964Z","key":1})]);
}

Edit.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Edit;

Edit.default = Edit;
